<template>
  <div id="authorize">
    <loading-modal :loading="true" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Authorize',
  components: {
    'loading-modal': () => import('@/components/shared/Loading')
  },
  methods: {
    ...mapActions([
      'handleAuthentication'
    ])
  },
  created: function () {
    this.handleAuthentication(this.$route.query.code, this.$route.query.scope)
      .then((data) => {
        return this.$router.replace({ name: 'AuthorizeUser' })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Authorize.vue